import { type BillingState } from '../useQueryDeliveryNoteAdmin/types';

import { type DeliveryNoteSummaryAdminResponse } from './types';

/** The API stores `billed_state` values; the UI names them like the calculated billing state. */
const BILLING_STATE_BY_BILLED_STATE = new Map<string, BillingState>([
  ['fully_billed', 'fullyBilled'],
  ['partially_billed', 'partiallyBilled'],
  ['unbilled', 'unbilled'],
]);

/**
 * Flattens an admin delivery note to the values that identify it.
 *
 * @param data - The delivery note (asset main) as returned by the API.
 * @returns The delivery note summary; absent values stay `null` or `undefined` as the API sent them.
 */
export function selectDeliveryNoteSummaryAdmin(
  data: DeliveryNoteSummaryAdminResponse,
) {
  const body = data.assetState?.body;
  const delivery = body?.transaction?.delivery;

  return {
    billingState: BILLING_STATE_BY_BILLED_STATE.get(data.billedState ?? ''),
    deliveryNoteDate: body?.header?.date,
    deliveryNoteNumber: body?.header?.id?.toString(),
    id: data.id,
    processState: data.processState,
    recipientName: delivery?.shipTo?.legalOrganization?.name,
    supplierName: delivery?.shipFrom?.legalOrganization?.name,
  };
}
